module.exports = __webpack_public_path__ + "static/media/work.a5036a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/work.png
// module id = 84
// module chunks = 0